<template>
  <div
    data-testid="studio-badge"
    class="tw-inline-flex tw-h-fit tw-w-fit tw-items-center tw-truncate tw-rounded-full tw-px-2.5 tw-text-center tw-text-2xs tw-font-medium"
    :class="{
      'tw-bg-indigo-100 tw-text-indigo-800': variation === 'default',
      'tw-bg-sky-50 tw-text-sky-600': variation === 'sky',
      'tw-bg-gray-100 tw-text-gray-800': variation === 'gray',
      'tw-bg-orange-50 tw-text-deep-orange-600': variation === 'orange',
      'tw-bg-rose-100 tw-text-rose-500': variation === 'red',
      'tw-bg-green-100 tw-text-green-800': variation === 'green'
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
export type BadgeVariants = 'default' | 'gray' | 'red' | 'orange' | 'green' | 'sky';

export default defineComponent({
  name: 'StudioBadge',
  props: {
    variation: {
      type: String as PropType<BadgeVariants>,
      default: 'default'
    }
  }
});
</script>
